export default __webpack_public_path__ + "static/media/JP4-2.024c2887.jpg";